import { inject, Injectable } from '@angular/core';
import { I18nService } from '@core/services/i18n.service';

@Injectable({
  providedIn: 'root',
})
export class LocaleIdService extends String {
  private i18nService = inject(I18nService);

  override toString(): string {
    return this.i18nService.currentLocaleCulture;
  }

  override valueOf(): string {
    return this.toString();
  }
}
